import React from 'react';
import { localize } from 'react-localize-redux';
import FlatButton from 'material-ui/FlatButton';
import { AccentColor } from 'helpers/AccentColorHelper';

const PrintButton = class extends React.Component {
  /*
   * Allow elements contained within a dialog or DIV to be printed.
   *
   * props:
   *
   * hideElementsByIds (array): Array of element ids that will also be hidden when printing.
   *   This is useful if you want to hide parts of the dialog in the print view.
   * 
   * printHeader (string): This is a string passed in to show the title at the top of the printed page.
   *   Only applicable when printing a selected DIV (not when printing a dialog). A printElementID
   *   prop must also be passed in.
   * 
   * printElementID (string): String of the desired DIV's ID that you would like to print.
   *   Only applicable when printing a selected DIV (not when printing a dialog).
   *
   */

  printByDiv = () => {
    // https://stackoverflow.com/questions/2255291/print-the-contents-of-a-div
    let mywindow = window.open('', 'PRINT', 'height=400,width=600');

    mywindow.document.write('<html><head><title>' + this.props.printHeader + '</title>');
    mywindow.document.write('</head><body >');
    mywindow.document.write(document.getElementById(this.props.printElementID).innerHTML);
    mywindow.document.write('</body></html>');

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();

    return true;
  };

  displayBackground = (display, additionalElementIds = []) => {
    const displayStyle = display ? '' : 'none';

    document.getElementById('root').style.display = displayStyle;
    Array.from(document.getElementsByTagName('button')).forEach(button => {
      button.style.display = displayStyle;
    });

    let element;
    additionalElementIds.forEach(elementId => {
      element = document.getElementById(elementId);
      if (element) {
        element.style.display = displayStyle;
      }
    });
  };

  print = () => {
    this.displayBackground(false, this.props.hideElementsByIds);
    window.print();
    this.displayBackground(true, this.props.hideElementsByIds);
  };

  render() {
    return (
      <FlatButton
        label={this.props.translate('print')}
        keyboardFocused={false}
        onClick={this.props.printElementID ? this.printByDiv : this.print}
        style={{ color: AccentColor(), backgroundColor: '#fff !important' }}
        {...this.props}
      />
    );
  }
};

export default localize()(PrintButton);
